import { emptyValidator, specialCharValidator } from '@core/utils/validation'
import { toastInfo } from '@core/utils/prompt'
import { isObject } from '@core/utils'

// eslint-disable-next-line import/prefer-default-export
export function filterDataProcess(data) {
  const keys = Object.keys(data)
  for (let i = 0; i < keys.length; i += 1) {
    if (specialCharValidator(data[keys[i]])) {
      toastInfo('请不要输入特殊字符查询！')

      return false
    }
    // eslint-disable-next-line no-param-reassign
    if (emptyValidator(data[keys[i]])) delete data[keys[i]]
    // eslint-disable-next-line no-param-reassign
    else if (typeof data[keys[i]] === 'string') data[keys[i]] = data[keys[i]].trim()
  }

  return data
}

export function parseDuration(duration) {
  if (!duration) return ''
  const durationInt = parseInt(duration, 10)
  const durationHour = Math.floor(durationInt / 3600)
  const durationMin = Math.floor(durationInt / 60)
  const durationSecond = durationInt % 60

  return `${durationHour ? `${durationHour} 时 ` : ''}${durationMin ? `${durationMin} 分 ` : ''}${durationSecond} 秒`
}

export function jsonParse(jsonStr) {
  try {
    if (!jsonStr) return {}

    return JSON.parse(jsonStr)
  } catch (e) {
    console.log(e)

    return {}
  }
}

export const dateGen = dateObj => `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getDate().toString().padStart(2, '0')}`
export const oneDay = 86400000 // 24 * 60 * 60 * 1000
export const oneWeek = 604800000 // 7 * 24 * 60 * 60 * 1000
export const oneMonth = 2592000000 // 30 * 24 * 60 * 60 * 1000

export const undefinedResolve = (val, undefinedVal = '') => (typeof val === 'undefined' ? undefinedVal : val)
export const booleanParser = val => (val === null ? null : val === 'true' || val === true || val)
export const intParser = val => (val === null ? null : parseInt(val, 10))
export const floatParser = (val, precision = 2) => (val === null ? null : parseFloat(val).toFixed(precision))
export const MultiInputParser = (val, splitChar = ' ') => (val === null ? null : val.replaceAll('\t', splitChar).split(splitChar).map(s => s.trim()).filter(i => i)
  .join(splitChar))
export const percentageParser = (val, precision = 2) => (val === null ? null : `${(parseFloat(val) * 100).toFixed(precision)} %`)

export const getDataWithKey = (data, key = 'value') => (isObject(data) && key in data ? data[key] : data)
export const getDataWithKeySplit = (data, keys = 'value') => keys?.split('.').filter(v => v).reduce((acc, cur) => (isObject(acc) && cur in acc ? acc[cur] : acc), data)
export const getData = (data, args, keys = 'value') => (typeof data === 'function' ? data.call(null, args) : getDataWithKey(data, keys))
export const curry = fn => {
  const judge = (...args) => (args.length >= fn.length
    ? fn(...args)
    : arg => judge(...args, arg))

  return judge
}

export const blobParser = (blobData, dateResolver) => new Promise((resolve, reject) => {
  try {
    const reader = new FileReader()
    reader.onload = event => {
      if (dateResolver) resolve(dateResolver(event.target.result))
      resolve(event.target.result)
    }
    reader.readAsText(blobData)
  } catch (e) {
    reject(e)
  }
})

export const getVideoData = file => new Promise((resolve, reject) => {
  // 获取视频或者音频时长
  try {
    const video = document.createElement('video')
    video.preload = 'metadata' // 仅加载元数据，包括时长信息
    video.onloadedmetadata = function getVideoDataInner() {
      const videoData = {
        duration: this.duration,
        videoWidth: this.videoWidth,
        videoHeight: this.videoHeight,
      }
      URL.revokeObjectURL(video.src)
      resolve(videoData)
    }

    video.onerror = function getVideoDataErr() {
      resolve({})
    }

    video.src = URL.createObjectURL(file)
  } catch (e) {
    reject(e)
  }
})

export const getMapFromArray = (arrayIn, objKey, objValue, dataFormatter) => arrayIn.reduce((obj, cur) => {
  // eslint-disable-next-line no-param-reassign
  obj[cur[objKey]] = typeof dataFormatter === 'function' ? dataFormatter(cur[objValue]) : cur[objValue]

  return obj
}, {})
